import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationHostTypeService, UserSessionService } from 'rome-library';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { States } from '../../shared';
import { TokenStore } from './../services/token.store';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  private readonly sessionTokenInQueryParamsEndpoints = [
    '/InternalConfiguration/Import',
    '/InternalConfiguration/uploadContent'
  ];
  private readonly automaticRequestsEndpoints = ['/ApplicationCase/IsNotificationAvailable'];

  private readonly _tokenStore: TokenStore;

  constructor(
    private readonly tokenStore: TokenStore,
    private readonly router: Router,
    private readonly userSessionService: UserSessionService,
    private readonly applicationHostTypeService: ApplicationHostTypeService
  ) {
    this._tokenStore = tokenStore;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const sessionToken = this._tokenStore.getSessionToken();
    const accessToken = this._tokenStore.getUserContext().AccessToken;
    const accessTokenGuid = this._tokenStore.getUserContext().AccessTokenGuid;

    let requestWithHeadersAndParams = request.clone({
      setHeaders: {
        From: `${this.applicationHostTypeService.getHash()}_@boi.com`
      }
    });
    Object.assign(request, requestWithHeadersAndParams);

    if (sessionToken !== undefined && accessTokenGuid !== undefined && accessToken !== undefined) {
      requestWithHeadersAndParams = request.clone({
        setHeaders: {
          From: `${this.applicationHostTypeService.getHash()}_${sessionToken}`,
          Authorization: `Bearer ${accessToken}`
        },
        setParams: {
          accessTokenGuid
        }
      });
      Object.assign(request, requestWithHeadersAndParams);
    }

    return next.handle(request).pipe(
      tap(
        (event) => {
          if (event instanceof HttpResponse) {
            const receivedSessionToken = event.headers.get('From');
            if (receivedSessionToken !== null) {
              this._tokenStore.setSessionToken(receivedSessionToken);

              if (this.automaticRequestsEndpoints.indexOf(request.url) < 0) {
                this.userSessionService.restartSession();
              }
            }
          }
        },
        (errorResponse) => {
          if (errorResponse instanceof HttpErrorResponse) {
            switch (errorResponse.status) {
              case 401:
                if (errorResponse.error.Message === 'SessionExpiration') {
                  void this.router.navigate(['/', this.applicationHostTypeService.getCode(), States.SessionClosed]);
                }
                break;
              case 403:
                void this.router.navigate(['/', this.applicationHostTypeService.getCode(), States.NoCaseAccess]);
                break;
              case 503:
                void this.router.navigate([this.applicationHostTypeService.getCode(), States.SystemUnavailable]);
                break;
              default:
                break;
            }
          }
        }
      )
    );
  }
}
